import Close from '@mui/icons-material/CloseRounded';
import {
  Button,
  DialogContent,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import StyledSnackbarProvider from '../../../../../Components/StyledSnackbarProvider';
import PageContentLayout from '../../../../../Layouts/PageContentLayout';
import PageHeader from '../../../../../Layouts/PageHeader';
import StyledDialog, { StyledLayout } from './styles';

export default function Layout(props: { children: React.ReactNode, sessionId: string | null, onClose: () => void }) {
  const { sessionId, onClose } = props;
  const { t } = useTranslation('session');
  const { children } = props;
  const { t: tCommon } = useTranslation('common');

  return (
    <StyledDialog open={!!sessionId} onClose={onClose} fullWidth maxWidth="sm">
      {sessionId && (
        <StyledSnackbarProvider>
          <DialogContent>
            <Button onClick={onClose} title={tCommon('close')}>
              <Close />
            </Button>
            <StyledLayout id="session-details-dialog">
              <PageHeader title={t('details.title')} />
              <PageContentLayout className="content">
                {children}
              </PageContentLayout>
            </StyledLayout>
          </DialogContent>
        </StyledSnackbarProvider>
      )}
    </StyledDialog>
  );
}
